import { makeStyles } from "@material-ui/core/styles";

const styles = makeStyles(theme => ({
  root: {
    flexGrow: 1
  },
  absoluteSContainer: {
    top: "56px",
    position: "absolute",
    background: "lightgrey",
    width: "100%",
    minHeight: "200px",
    color: "#727272",
    justifyContent: "center",
    display: "flex",
    backgroundColor: "#f3f3f3",
    zIndex: 2,
    left: "0",
    right: 0,
    marginLeft: "auto",
    marginRight: "auto",
    maxWidth: "960px",
    boxShadow:
      "0 2px 4px -1px rgb(0 0 0 / 20%), 0 1px 10px 0 rgb(0 0 0 / 12%), 0 4px 5px 0 rgb(0 0 0 / 14%)",
    borderBottomLeftRadius: "8px",
    borderBottomRightRadius: "8px"
  },
  mainContainer: {
    flexDirection: "row",
    alignItems: "start",
    justifyContent: "center",
    display: "flex",
    marginTop: 20,
    marginBottom: 20
  },
  displayFlex: {
    display: "flex"
  },
  cardMedicalAssistenceContainer: {
    width: "260px",
    height: "75px",
    margin: "0 10px 10px 0",
    padding: "7px 0 5px 12px",
    borderRadius: "2px",
    backgroundColor: "#fafafa",
    position: "relative",
    fontFamily: "Trebuchet",
    textDecoration: "none !important",
    "&:hover": {
      transform: "translateX(0px) translateY(-5px)!important",
      boxShadow:
        "0 2px 4px -1px rgb(0 0 0 / 20%), 0 1px 10px 0 rgb(0 0 0 / 12%), 0 4px 5px 0 rgb(0 0 0 / 14%)",
      transition: "transform 300ms ease 0ms",
      "& $colorGris": {
        color: theme.palette.primary.dark
      }
    }
  },
  titleMedicalAssistence: {
    fontSize: "15px",
    fontWeight: "bold",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "1.07",
    letterSpacing: "normal",
    color: "#00338d",
    marginBottom: "3px"
  },
  descriptionMedicalAssistence: {
    fontSize: "12px",
    fontWeight: "normal",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "1.08",
    letterSpacing: "-0.19px",
    color: "#727272",
    marginBottom: "3px"
  },
  arrowContainer: {
    position: "absolute",
    bottom: "0px",
    right: "0px"
  },
  arrowIcon: {
    fontSize: "14px",
    marginLeft: "8px",
    fontWeight: 700
  },
  colorGris: {
    color: "#e7e7e7"
  },
  titleChanelServices: {
    fontSize: "15px",
    fontWeight: 500,
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "normal",
    letterSpacing: "normal",
    textAlign: "left",
    color: "#00338d",
    marginBottom: "12px"
  },
  dividerChanelServices: {
    width: "1px",
    height: "310px",
    margin: "0 19.5px",
    border: "solid 1px #979797",
    background: "#979797"
  },

  //MEGA MENU 2.0

  coberturaEcuadorMegaMenu: {
    display: "flex",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    minHeight: "260px",
    width: "100%",
    backgroundColor: "#f3f3f3",
    borderBottomRightRadius: "8px",
    borderBottomLeftRadius: "8px",
    boxShadow:
      "0 2px 4px -1px rgb(0 0 0 / 20%), 0 1px 10px 0 rgb(0 0 0 / 12%), 0 4px 5px 0 rgb(0 0 0 / 14%)",
    fontFamily: "Trebuchet",
    flexDirection: "column"
  },
  megaMenuMedicMundial: {
    display: "flex",
    alignItems: "center",
    padding: "28px 35px",
    justifyContent: "space-between"
  },
  tituloContenedorCoberturaMegaMenu: {
    fontSize: "24px",
    fontWeight: "bold",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "0.83",
    letterSpacing: "-0.38px",
    marginBottom: "13px",
    color: "#00338d",
    textShadow: "none"
  },
  subtituloContenedorCoberturaMegaMenu: {
    fontSize: "16px",
    fontWeight: "normal",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "1.21",
    letterSpacing: "normal",
    marginTop: "20px",
    color: "#727272"
  },
  tituloCanalesServiciosMegaMenu: {
    fontSize: "15px",
    fontWeight: "bold",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "1.07",
    letterSpacing: "normal",
    color: "#00338d",
    marginBottom: "12px"
  },
  descripcionTarjetaAsistenciaMedica: {
    fontSize: "14px",
    fontWeight: "normal",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "1.08",
    letterSpacing: "-0.19px",
    marginBottom: "3px",
    paddingTop: "3px",
    color: "#0073cf",
    paddingRight: "0",
    textDecoration: "none"
  },
  lineaDivisorCanalesServicios: {
    height: "146px",
    margin: "0 19.5px",
    border: "solid 0.9px #cfcfcf"
  },
  imageCsMegaMenu: {
    marginBottom: "30px",
    display: "block",
    marginLeft: "auto",
    marginRight: "auto"
  },
  linkPageCoberturaMegaMenu: {
    display: "flex",
    textDecoration: "none",
    alignItems: "center",
    width: "fit-content"
  },
  colorlightBlue: {
    color: "#0073cf"
  },
  iconSize: {
    fontSize: 10,
    fontWeight: "bold"
  },
  botonesCoberturaFrenteCancerMegaMenu: {
    backgroundColor: "transparent",
    width: "140px",
    textAlign: "center",
    padding: "11px 0",
    borderRadius: "8px",
    border: "solid 1px #ffffff",
    display: "flex",
    justifyContent: "center",
    textDecoration: "none",
    fontSize: "14px",
    color: "white"
  }
}));

export default styles;
